import { ControlPosition, IControl, Map } from 'maplibre-gl';

export class SearchControl implements IControl {
  constructor(private container: HTMLElement) {}

  onAdd(_: Map): HTMLElement {
    return this.container;
  }

  onRemove(_: Map): void {
    this.container.parentNode!.removeChild(this.container);
  }

  public getDefaultPosition(): ControlPosition {
    return 'top-right';
  }
}
